module.exports = __webpack_public_path__ + "assets/img/17_1412.634ec28f.jpg";